import React from "react";
import queryString from "query-string";
import http from "../http/index";
import Spinner from "../components/UI/Spinner/Spinner.component";
import SearchResults from "../components/searchResults.component";

class Search extends React.Component {
  state = {
    searchText: "",
    searchResuts: [],
    loading: true,
    searchIn: "1",
  };
  componentDidMount() {
    const { search } = this.props.location;
    const parseQuery = queryString.parse(search);
    if (!parseQuery.searchKey) {
      this.props.history.push("/");
    }
    this.setState({ searchText: parseQuery.searchKey }, () => {
      this.getSearchResults();
    });
  }
  getSearchResults = async () => {
    const { searchText, searchIn } = this.state;
    try {
      this.props.history.push({ search: `?searchKey=${searchText}` });
      const result = await http.get("/searchByResults", {
        params: { searchText, searchIn },
      });
      this.setState({ searchResuts: result.data.results, loading: false });
    } catch {
      this.setState({ searchResuts: [], loading: false });
    }
  };
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    this.getSearchResults();
  };
  render() {
    const { searchText, searchResuts, loading, searchIn } = this.state;
    return (
      <div className="col-12 col-sm-12 col-md-8 col-lg-9">
        <div className="sectionTitle blueTitleBg clearfix d-flex mb-4">
          <h2 className="m-0 float-left mr-auto px-3">Search Form</h2>
        </div>
          <div className="form-seaction">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row">
                <div className="col">
                  <select name="searchIn" className="custom-select" defaultValue={searchIn} onChange={(e) => this.handleChange(e)}>
                    <option value="1">Article</option>
                    <option value="2">Comments</option>
                    <option value="3">Comments Posted By </option>
                  </select>
                </div>
                <div className="col">
                  <input
                    onChange={(e) => this.handleChange(e)}
                    type="text"
                    className="form-control"
                    placeholder="search text"
                    name="searchText"
                    value={searchText}
                  />
                </div>
                <button type="submit" className="btn btn-primary mb-2" disabled={loading ? "disabled" : ""}>
                  <i className="fa fa-search"></i>
                </button>
              </div>
            </form>
          </div>
          <div className="search-results">
            {loading ? <Spinner /> : <SearchResults data={searchResuts} />}
          </div>
      </div>
    );
  }
}

export default Search;
